import * as React from 'react';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import b_ from 'b_';
import { actions } from '../../actions/app';
import { languages } from './consts';
import { selector } from './selectors';

import './index.scss';

const b = b_.with('language-selector');

interface Props {}

type Enhanced = Props & { languages: typeof languages } & ReturnType<typeof selector> & {
    changeLanguage: typeof actions.changeLanguage;
  };

const enhance = compose<Enhanced, Props>(
  withProps(() => ({ languages })),
  connect(selector, {
    changeLanguage: actions.changeLanguage,
  })
);

class LanguageSelector extends React.Component<Enhanced> {
  render() {
    return (
      <li className={b('', { position: 'footer' })}>
        {this.renderSelected()}
        {this.renderOptions()}
      </li>
    );
  }

  private renderSelected() {
    const { language, languages } = this.props;
    const selected = languages.find(({ code }) => language === code);
    return (
      <React.Fragment>
        <img src={selected && selected.languageImg} className={b('img')} />
        <div className={b('selected')}>{selected ? selected.shortLabel : language}</div>
      </React.Fragment>
    );
  }

  private renderOptions() {
    const { language, languages, changeLanguage, newLangEs } = this.props;

    return (
      <ul className={b('options')}>
        {languages
          .filter(({ code }) => newLangEs || code != 'es')
          .map(({ code, label }) => (
            <li
              key={code}
              className={b('option', { active: code === language })}
              onClick={() => changeLanguage(code)}
            >
              {label}
            </li>
          ))}
      </ul>
    );
  }
}

export default enhance(LanguageSelector);
